'use strict';

import $ from 'jquery';

class Vector2 {
  constructor(x, y) {
    this.x = x || 0;
    this.y = y || 0;
  }

  scale(num) {
    this.x *= num;
    this.y *= num;
  }

  static distance(a, b) {
    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
  }
}

class ParallaxElement {
  constructor(elem, range) {
    this.elem = elem;
    this.range = range;

    this.elem.classList.add('parallax');

    this.curPos = new Vector2();
    this.endPos = new Vector2();

    this.interval;

    this.elem.style.transition = 'none';
  }

  move(x, y) {
    if (window.innerWidth <= 600) {
      this.elem.style.transform = '';
      this.stop();

      return;
    }

    this.endPos.x = this.range * x;
    this.endPos.y = this.range * y;

    this.endPos.scale(2);

    if (!this.interval) {
      this.interval = setInterval(() => {
        this.curPos.x += 0.01 * (this.endPos.x - this.curPos.x);
        this.curPos.y += 0.01 * (this.endPos.y - this.curPos.y);

        this.elem.style.transform = `translate3d(
          ${this.curPos.x}px,
          ${this.curPos.y}px,
          0
        )`;

        if (Vector2.distance(this.curPos, this.endPos) < 1) {
          this.stop();
        }
      });
    }
  }

  stop() {
    clearInterval(this.interval);
    this.interval = null;
  }
}

const children = [];

function setParallaxChildren(el) {
  let toRemove = [].concat(children);

  $(el)
    .find('*[parallax-child]')
    .each(function() {
      if (!children.includes(this)) {
        let depth = parseFloat(this.attributes['parallax-child'].value);
        let pe = new ParallaxElement(this, !isNaN(depth) ? depth : 5);

        children.push(pe);
      } else {
        toRemove.splice(toRemove.indexOf(this), 1);
      }
    });

  toRemove.forEach(item => {
    children.splice(children.indexOf(item), 1);
  });
}

const parallaxZone = {
  bind(el, binding) {
    setParallaxChildren(el);

    $(el).mousemove(e => {
      children.forEach(pe => {
        let x = 1 - e.pageX / (window.innerWidth * 0.5);
        let y = 1 - e.pageY / (window.innerHeight * 0.5);

        pe.move(x, y);
      });
    });

    $(el).mouseleave(e => {
      children.forEach(pe => {
        pe.move(0, 0);
      });
    });
  },
  componentUpdated(el, binding) {
    setParallaxChildren(el);

    console.log('PZ - changed');
  },
  unbind(el) {}
};

export default parallaxZone;



// WEBPACK FOOTER //
// ./src/directives/parallax-zone.js